var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0833333,11.9166667 C21.5893333,11.9166667 22,12.3273333 22,12.8333333 L22,12.8333333 L22,21.0833333 C22,21.5893333 21.5893333,22 21.0833333,22 L21.0833333,22 L12.8333333,22 C12.3273333,22 11.9166667,21.5893333 11.9166667,21.0833333 L11.9166667,21.0833333 L11.9166667,12.8333333 C11.9166667,12.3273333 12.3273333,11.9166667 12.8333333,11.9166667 L12.8333333,11.9166667 Z M9.16666667,11.9166667 C9.67266667,11.9166667 10.0833333,12.3273333 10.0833333,12.8333333 L10.0833333,12.8333333 L10.0833333,21.0833333 C10.0833333,21.5893333 9.67266667,22 9.16666667,22 L9.16666667,22 L0.916666667,22 C0.410666667,22 -3.73034936e-14,21.5893333 -3.73034936e-14,21.0833333 L-3.73034936e-14,21.0833333 L-3.73034936e-14,12.8333333 C-3.73034936e-14,12.3273333 0.410666667,11.9166667 0.916666667,11.9166667 L0.916666667,11.9166667 Z M21.0833333,-8.8817842e-15 C21.5893333,-8.8817842e-15 22,0.410666667 22,0.916666667 L22,0.916666667 L22,9.16666667 C22,9.67266667 21.5893333,10.0833333 21.0833333,10.0833333 L21.0833333,10.0833333 L0.916666667,10.0833333 C0.410666667,10.0833333 0,9.67266667 0,9.16666667 L0,9.16666667 L0,0.916666667 C0,0.410666667 0.410666667,-8.8817842e-15 0.916666667,-8.8817842e-15 L0.916666667,-8.8817842e-15 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/TemplateIcon.bc9e13c8bad1010dd46187c85f8fec99.svg";
export { ForwardRef as ReactComponent };